<style lang="stylus">
.live-video {
  height: 260px;
  margin: 24px;
  margin-bottom: 0;
  text-align: center;
}

.video-container {
  overflow: hidden;
  display: block;
  height: 283px;
  margin-bottom: 12px;
}

@media (max-width: 600px) {
  .video-container {
    overflow: hidden;
    display: block;
    height: 396px;
  }

  .live-video {
    height: 369px;
    width: 290px;
    margin: 24px;
    margin-bottom: 0;
    text-align: center;
    object-fit: fill;
  }
}
</style>
<template>
  <div>
    <div class="video-container">
      <video ref="video" id="video" class="live-video" autoplay muted playsinline />
    </div>

    <div style="text-align: center">
      <v-btn
        class="camera-icon mt-2"
        :ripple="false"
        :depressed="true"
        color="#8C1D40"
        @click="
          asuoDataLayerClick('idVerifiyStep1', '2', {});
          capture();
        "
      >
        <v-icon size="26px">mdi-camera</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import cameraShutterSound from '../assets/sounds/Camera-Shutter-www.fesliyanstudios.com.mp3';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';

export default defineComponent({
  emits: ['capture'],
  name: 'VideoComponent',

  data() {
    return {
      video: {},
      sound: cameraShutterSound
    };
  },

  mixins: [DataLayerMixin],

  methods: {
    async capture() {
      var cameraCapture = new Audio(this.sound);

      cameraCapture.volume = 0.2;

      await cameraCapture.play();

      this.$emit('capture', {
        video: this.video
      });
    }
  },

  async mounted() {
    this.video = this.$refs.video;

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.getUserMedia =
        navigator.mediaDevices.getUserMedia ||
        navigator.mediaDevices.webkitGetUserMedia ||
        navigator.mediaDevices.mozGetUserMedia ||
        navigator.mediaDevices.msGetUserMedia ||
        navigator.mediaDevices.oGetUserMedia;

      if (navigator.getUserMedia) {
        let constraints = {
          video: {
            width: {
              min: 440
            },
            height: {
              min: 260
            }
          }
        };
        this.video.srcObject = await navigator.mediaDevices.getUserMedia(constraints);

        // this.video.play();
      }
    }
  },

  beforeUnmount() {
    if (this.video && this.video.srcObject) {
      this.video.srcObject.getTracks().forEach(function (track) {
        track.stop();
      });
    }
  }
});
</script>
